import { styled, Typography } from '@mui/material';

// Título a UNA línea con ellipsis: es el ancla de lectura de la fila y nunca debe envolver.
const StyledNotificationTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontWeight: 700,
  letterSpacing: '-0.01em',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}));

export default StyledNotificationTitle;
